<template>
  <div>
    <div :class="s.footer">
      <img :src="require('../images/bigLogo.png')" alt="" />
      <div :class="s.infos">
        <div
          :class="s.infoList"
          v-for="({ header, children }, index) in list"
          :key="index"
        >
          <h3>{{ header }}</h3>
          <h4 v-for="(item, ind) in children" :key="ind">{{ item }}</h4>
        </div>
      </div>
    </div>
    <div :class="s.copyInfo">
      Copyright 上海妙保保险经纪股份有限公司 All Rights Reserved.&nbsp; |&nbsp;
      备案号：<a href="https://beian.miit.gov.cn/"> 沪ICP备17025222号-2</a>
    </div>
  </div>
</template>

<script>
const list = [
  {
    header: "关于妙保",
    children: [
      "公司简介",
      "领导致辞",
      "企业文化",
      "组织构架",
      "大事记",
      "资质证书",
    ],
  },
  {
    header: "新闻中心",
    children: ["通知公告"],
  },
  {
    header: "妙保服务",
    children: ["服务范围", "合作客户", "保险服务"],
  },
  {
    header: "公开信息披露",
    children: ["自营网站、微信", "第三方平台报备"],
  },
  {
    header: "友情链接",
    children: ["监管部门", "保险公司", "合作伙伴"],
  },
];
export default {
  computed: {
    s() {
      return this.$style;
    },
  },
  data() {
    return { list };
  },
};
</script>

<style scoped lang="less" module>
h3,
h4 {
  margin: 0;
}
.footer {
  display: none;
  align-items: center;
  justify-content: space-between;
  width: 1075px;
  margin: 150px auto 75px;
  h3 {
    font-size: 14px;
    margin-bottom: 22px;
  }
  h4 {
    font-size: 14px;
    color: #999999;
    margin-bottom: 9px;
  }
}
.infos {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.infoList {
  height: 175px;
  margin: 0 45px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.copyInfo {
  margin: 80px auto 70px;
  font-size: 14px;
  text-align: center;
  a {
    color: #2c3e50;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/components/Footer.vue